import { useTranslations } from "@jugl-web/utils";
import React from "react";

export const NotTrainedPill: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="flex h-7 shrink-0 items-center justify-center rounded-xl border border-solid border-tertiary-100 bg-tertiary-50 px-2">
      <span className="font-secondary text-xs font-medium text-dark-800">
        {t({
          id: "cx-ai-agents-page.not-trained",
          defaultMessage: "Not trained",
        })}
      </span>
    </div>
  );
};
